import { Close } from '@1debit/icons';
import Image from 'next/image';
import Button from 'components/shared/Buttons/BaseButton';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';
import { cn } from 'utils/styles';
import { TOAST_CARD_SHELL, TOAST_TEXT } from './consts';
import type { ToastCardProps } from './types';

/**
 * The `dismissable toast` surface: a corner card closed with an X. Media and CTA
 * are both optional, which covers the six combinations in the design.
 */
const ToastCard = ({ category, headline, media, cta, ctaAsButton, onDismiss, className }: ToastCardProps) => (
  <div className={cn(TOAST_CARD_SHELL, 'flex items-start justify-between gap-4', className)}>
    <div className="flex min-w-0 items-center gap-4">
      {media?.url && (
        <Image
          src={media.url}
          alt={media.description ?? ''}
          width={72}
          height={72}
          className="size-[72px] shrink-0 object-contain"
        />
      )}
      <div className={cn('flex min-w-0 flex-col gap-4', TOAST_TEXT)}>
        <div className="flex flex-col gap-1">
          {category && <p className="text-grey-200">{category}</p>}
          <p className="text-kale">{headline}</p>
        </div>
        {isValidCta(cta) && (
          <CTA
            cta={cta}
            variant={ctaAsButton ? 'solid' : 'link'}
            className={ctaAsButton ? 'w-fit' : 'w-max text-kale'}
            testId={ctaAsButton ? 'toastCtaButton' : undefined}
          />
        )}
      </div>
    </div>
    <Button variant="icon" label="Dismiss" onClick={onDismiss} className="w-max shrink-0 p-1">
      <Close />
    </Button>
  </div>
);

export default ToastCard;
